import { Component, inject } from '@angular/core';
import { AppMaterialModule } from '../../../shared/app-material/app-material.module';
import { SharedModule } from '../../../shared/shared.module';
import { SocialMediaComponent } from '../../../shared/components/social-media/social-media.component';
import { GlobalConfigService } from '../../services/global-config.service';

@Component({
    selector: 'app-footer',
    imports: [SharedModule, SocialMediaComponent],
    templateUrl: './footer.component.html',
    standalone: true,
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  readonly globalData = inject(GlobalConfigService);
}
